import { Fragment } from "react";
import DateRange from "../../../../../Forms/components/Question/Inputs/DateRange";
import TextInput from "../../../../../Forms/components/Question/Inputs/TextInput";
import { formConstants } from "../../../../util/constants";

function AdminSessionQuestions({ id = "", errors = {}, handleChange, formData = {} }) {
  const periodEndValue = formData[formConstants.names[formConstants.ids.periodEnd]]

  return (
    <Fragment>
      <TextInput
        id={id + "-" + formConstants.ids.label}
        name={formConstants.names[formConstants.ids.label]}
        value={formData[formConstants.names[formConstants.ids.label]]}
        label={formConstants.labels[formConstants.ids.label]}
        setValue={handleChange}
        description="Display name for this session"
        required={false}
      />

      <TextInput
        id={id + "-" + formConstants.ids.description}
        name={formConstants.names[formConstants.ids.description]}
        value={formData[formConstants.names[formConstants.ids.description]]}
        label={formConstants.labels[formConstants.ids.description]}
        setValue={handleChange}
        area
        required={false}
        description="Optional detailed description of the session"
      />

      <DateRange
        id={id + "-reporting-period"}
        label="Reporting Period"
        required
        startValue={formData[formConstants.names[formConstants.ids.periodStart]]}
        endValue={periodEndValue}
        onStartChange={handleChange}
        onEndChange={handleChange}
        startError={!!errors.start}
        endError={!!errors.end}
        startHelperText={errors.start}
        endHelperText={errors.end}
        startLabel={formConstants.labels[formConstants.ids.periodStart]}
        endLabel={formConstants.labels[formConstants.ids.periodEnd]}
        startName={formConstants.names[formConstants.ids.periodStart]}
        endName={formConstants.names[formConstants.ids.periodEnd]}
        format="MM/dd/yyyy hh:mm a"
      />

      <DateRange
        id={id + "-submissions-window"}
        label="Submissions Window"
        required
        startValue={formData[formConstants.names[formConstants.ids.formsOpenDate]]}
        startReferenceDate={periodEndValue}
        endValue={formData[formConstants.names[formConstants.ids.formsCloseDate]]}
        onStartChange={handleChange}
        onEndChange={handleChange}
        startLabel={formConstants.labels[formConstants.ids.formsOpenDate]}
        endLabel={formConstants.labels[formConstants.ids.formsCloseDate]}
        startName={formConstants.names[formConstants.ids.formsOpenDate]}
        endName={formConstants.names[formConstants.ids.formsCloseDate]}
        startError={!!errors.formsOpenDate}
        endError={!!errors.formsCloseDate}
        startHelperText={errors.formsOpenDate}
        endHelperText={errors.formsCloseDate}
        format="MM/dd/yyyy hh:mm a"
      />
    </Fragment>
  );
}

export default AdminSessionQuestions;
